import 'twin.macro';
import React from 'react';
import { CheckBadgeIcon as BadgeCheck } from '@heroicons/react/24/outline';
import { Alert } from './Alert';
import SchoolyearButtonLink from '@teetsh/app/src/components/Buttons/SchoolyearButtonLink';
import livretsUrls from '@teetsh/app/src/containers/Livrets/urls';
import { LsuError } from '@teetsh/app/src/containers/Livrets/types/livret';
import Disclosure from '@teetsh/app/src/components/Disclosure';
import { Trans, useTranslation } from 'react-i18next';
import { useLSUErrorsMapping } from 'containers/Livrets/useLSUErrorsMapping';
import { large } from 'i18n/components';

interface Props {
  errors: LsuError[];
  livretEvalId: string;
  eleveId: string;
}

export function LSUCompatibility(props: Props) {
  const { errors, livretEvalId, eleveId } = props;
  const errorsMapping = useLSUErrorsMapping();
  const { t } = useTranslation(['carnet']);
  if (errors.length === 0) {
    return (
      <div tw="inline-block">
        <div tw="font-medium text-lg text-positive-intense flex items-center bg-positive-quiet px-3 py-0.5 rounded-full">
          <BadgeCheck tw="h-6 w-6 mr-2" />
          {t('carnet:livret.lsuCompatible')}
        </div>
      </div>
    );
  }
  return (
    <Disclosure>
      <Disclosure.Button
        tw="appearance-none bg-danger-quiet"
        minimal
        intent="danger"
      >
        <Trans
          i18nKey="carnet:livret.lsuErrors"
          values={{ count: errors.length }}
          components={{ large }}
        />
      </Disclosure.Button>
      <Disclosure.Panel>
        <div tw="mt-2">
          {errors.map(err => {
            const error = errorsMapping(err.code);
            if (!error) {
              return (
                <Alert tw="mb-2" border key={err.code} title={err.message} />
              );
            }
            const { link } = error;
            const label = error.takeLabelFromTheBack
              ? err.message
              : error.label;

            if (!link) {
              return (
                <Alert tw="mb-2" border key={err.code} title={err.message} />
              );
            }
            return (
              <Alert tw="mb-2" border key={err.code} title={label || ''}>
                <SchoolyearButtonLink
                  to={`${livretsUrls.livretEleveDetails(
                    livretEvalId,
                    eleveId,
                  )}/${link}`}
                >
                  {t('carnet:livret.update')}
                </SchoolyearButtonLink>
              </Alert>
            );
          })}
        </div>
      </Disclosure.Panel>
    </Disclosure>
  );
}
